<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="!isLoading"
    class="flex flex-row items-center gap-5 font-semibold text[#424242] dark:text-white mb-8 mx-5 cursor-pointer">
    <p onclick="history.back()"> Centre Target</p>
    <p>Assign Officer Target</p>
</div>

<div *ngIf="!isLoading">
    <div class="font-semibold text[#424242] mb-8 dark:bg-[#363636] mx-0 rounded-lg dark:text-[#FFFFFF]">
        <div class="flex flex-col bg-[#FFFFFF] dark:bg-[#363636] pt-6 pb-4 rounded-lg items-center justify-center ">
            <p class="text-lg text-black dark:text-white font-bold">{{targetVerity.cropNameEnglish}} :
                {{targetVerity.varietyNameEnglish}}
            </p>
            <p class="text-black font-semibold dark:text-textDark">Daily Target for <span
                    class="text-[#415CFF]">{{targetVerity.formattedToDate}}</span></p>

            <div class="border-[1px] border-[#E5E7EB] my-5 rounded-lg">
                <table>
                    <tr class="border-b-2">
                        <th class="px-8 py-1 text-[#4B5563] dark:text-white font-normal">
                            <p>Grade A</p>
                            <p>(Kg)</p>
                        </th>
                        <th class="px-8 py-1 text-[#4B5563] dark:text-white font-normal">
                            <p>Grade B</p>
                            <p>(Kg)</p>
                        </th>
                        <th class="px-8 py-1 text-[#4B5563] dark:text-white font-normal">
                            <p>Grade C</p>
                            <p>(Kg)</p>
                        </th>
                    </tr>
                    <tr>
                        <th class="px-8 py-4 text-[#4B5563] font-normal">
                            <div
                                class="bg-[#F6F7F9] dark:bg-slate-500 border-[1px] border-[#415CFF] rounded-lg px-3 py-1">
                                <p class="text-black dark:text-white font-semibold">{{targetVerity.qtyA }}</p>
                            </div>
                        </th>
                        <th class="px-8 py-4 text-[#4B5563] font-normal">
                            <div
                                class="bg-[#F6F7F9] dark:bg-slate-500 border-[1px] border-[#415CFF] rounded-lg px-3 py-1">
                                <p class="text-black dark:text-white font-semibold">{{targetVerity.qtyB }}</p>
                            </div>
                        </th>
                        <th class="px-8 py-4 text-[#4B5563] font-normal">
                            <div
                                class="bg-[#F6F7F9] dark:bg-slate-500 border-[1px] border-[#415CFF] rounded-lg px-3 py-1">
                                <p class="text-black dark:text-white font-semibold">{{targetVerity.qtyC }}</p>
                            </div>
                        </th>
                    </tr>
                </table>
            </div>
        </div>
    </div>

    <div class="w-full min-w-0 px-4 sm:px-6 lg:px-10 py-7 bg-tileLight dark:bg-[#363636] shadow-lg rounded-lg my-8">
        <div class="w-full min-w-0 mt-5 border-gray-100 border-[2px] rounded-lg dark:border-[#202021] overflow-x-auto">
            <table class="w-full min-w-max divide-y-2">
                <thead class="text-gray-700 dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021] cursor-default">
                    <tr>
                        <th class="px-6 py-3 text-left font-medium">No</th>
                        <th class="px-6 py-3 text-left font-medium">EMP ID</th>
                        <th class="px-6 py-3 text-left font-medium">Full Name</th>
                        <th class="px-6 py-3 text-left font-medium">Grade A</th>
                        <th class="px-6 py-3 text-left font-medium">Grade B</th>
                        <th class="px-6 py-3 text-left font-medium">Grade C</th>
                    </tr>
                </thead>
                <tbody class="bg-white dark:bg-[#1D1D1F] dark:border-[#1D1D1F]">
                    <tr *ngFor="let item of officerArr; let i = index">
                        <td class="px-6 py-4 text-sm text-gray-900 dark:text-gray-300">
                            {{ (i + 1) < 10 ? '0' + (i + 1) : (i + 1) }} </td>
                        <td class="px-6 py-4 text-sm text-gray-900 dark:text-gray-300">{{item.empId}}</td>
                        <td class="px-6 py-4 text-sm text-gray-900 dark:text-gray-300">{{item.firstNameEnglish}}
                            {{item.lastNameEnglish}}</td>
                        <td class="px-6 py-4 text-sm text-gray-900 dark:text-gray-300">
                            <input step="any" type="number" [(ngModel)]="officerArr[i].targetA" name="targetA"
                                (ngModelChange)="updateTotals(i, 'A')" (input)="restrictDecimals($event, i, 'A')"
                                (keydown.-)="$event.preventDefault()" (paste)="preventNegativePaste($event)"
                                class="border-[#415CFF] border-[2px] border-dotted dark:bg-slate-500 rounded-lg w-28 px-2 py-1" />
                        </td>
                        <td class="px-6 py-4 text-sm text-gray-900 dark:text-gray-300">
                            <input step="any" type="number" [(ngModel)]="officerArr[i].targetB" name="targetB"
                                (ngModelChange)="updateTotals(i, 'B')" (input)="restrictDecimals($event, i, 'B')"
                                (keydown.-)="$event.preventDefault()" (paste)="preventNegativePaste($event)"
                                class="border-[#415CFF] border-[2px] border-dotted dark:bg-slate-500 rounded-lg w-28 px-2 py-1" />
                        </td>
                        <td class="px-6 py-4 text-sm text-gray-900 dark:text-gray-300">
                            <input step="any" type="number" [(ngModel)]="officerArr[i].targetC" name="targetC"
                                (ngModelChange)="updateTotals(i, 'C')" (input)="restrictDecimals($event, i, 'C')"
                                (keydown.-)="$event.preventDefault()" (paste)="preventNegativePaste($event)"
                                class="border-[#415CFF] border-[2px] border-dotted dark:bg-slate-500 rounded-lg w-28 px-2 py-1" />
                        </td>
                    </tr>
                    <tr class="border-t-2 border-[#E5E7EB]">
                        <td class="px-6 py-3 text-gray-900 dark:text-gray-300"></td>
                        <td class="px-6 py-3text-gray-900 dark:text-gray-300"></td>
                        <td class="px-6 py-3 font-bold text-end text-gray-900 dark:text-gray-300">Total : </td>
                        <td class="px-6 py-3 text-gray-900 dark:text-gray-300">
                            <div class="flex flex-row gap-2">
                                <input type="number" step="any" [value]="totTargetA" disabled
                                    class="border-[#415CFF] dark:bg-slate-500 border-[2px] border-dotted rounded-lg w-28 px-2 py-1" />
                                <div *ngIf="+totTargetA === +targetVerity.qtyA"
                                    class="bg-[#415CFF] text-[#FFFFFF] flex justify-center items-center px-3 py-1 rounded-full">
                                    <i class="fa-solid fa-check text-sm"></i>
                                </div>
                            </div>
                        </td>
                        <td class="px-6 py-3  text-gray-900 dark:text-gray-300">
                            <div class="flex flex-row gap-2">
                                <input type="number" step="any" [value]="totTargetB" disabled
                                    class="border-[#415CFF] dark:bg-slate-500 border-[2px] border-dotted rounded-lg w-28 px-2 py-1" />
                                <div *ngIf="+totTargetB === +targetVerity.qtyB"
                                    class="bg-[#415CFF] text-[#FFFFFF] flex justify-center items-center px-3 py-1 rounded-full">
                                    <i class="fa-solid fa-check text-sm"></i>
                                </div>
                            </div>

                        </td>
                        <td class="px-6 py-3 text-gray-900 dark:text-gray-300">
                            <div class="flex flex-row gap-2">
                                <input type="number" step="any" [value]="totTargetC" disabled
                                    class="border-[#415CFF] dark:bg-slate-500 border-[2px] border-dotted rounded-lg w-28 px-2 py-1" />
                                <div *ngIf="+totTargetC == +targetVerity.qtyC"
                                    class="bg-[#415CFF] text-[#FFFFFF] flex justify-center items-center px-3 py-1 rounded-full">
                                    <i class="fa-solid fa-check text-sm"></i>
                                </div>
                            </div>

                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="flex flex-row justify-center items-center my-7 gap-8">
            <button class="bg-[#FFFFFF] text-[#6B7D8C] border-[2px] border-[#95A1AC] rounded-lg px-5 py-2"
                (click)="onCancel()">
                Cancel
            </button>
            <button class="rounded-lg px-7 py-2"
                [ngClass]="isFormValid ? 'bg-[#415CFF] text-[#FFFFFF]' : 'bg-[#F6F7F9] text-[#6B7D8C] border-[2px] border-[#95A1AC]'"
                (click)="isFormValid && onSubmit()">
                Save
            </button>
        </div>

    </div>
</div>
